import Separator from "@/app/components/lib/Separator";
import { JSX } from "react";

interface props {
  title: JSX.Element | string;
  children: React.ReactNode;
}

const BoxWithTitle: React.FC<props> = ({ title, children }) => {
  return (
    <div className="box-with-title">
      <Separator startLabel={title} />
      {children}
    </div>
  );
};

export default BoxWithTitle;
